import type { ProjectResourceGroup } from '@modules/project-keys/project-keys.interface'

import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'
import type { GatewayListFilterFormSlice, GatewayListFilterTraitsSource } from '../types/gatewayListFilters.types'

import {
  buildGatewayListModuleOptions,
  buildGatewayListProjectKeyOptions,
  buildGatewayListRuntimeOptions,
  buildGatewayListStatusOptions,
} from './buildGatewayListFilterOptions'

export function buildGatewayListFilterOptionSets(
  sources: GatewayListFilterTraitsSource[],
  filters: Pick<GatewayListFilterFormSlice, 'status' | 'runtime' | 'feed' | 'projectKey'>,
  projectKeyGroups: ProjectResourceGroup[] = []
) {
  const filterSlice: GatewayListFilterFormSlice = {
    status: filters.status ?? GATEWAY_LIST_FILTER_ALL,
    runtime: filters.runtime ?? GATEWAY_LIST_FILTER_ALL,
    feed: filters.feed ?? GATEWAY_LIST_FILTER_ALL,
    projectKey: filters.projectKey ?? GATEWAY_LIST_FILTER_ALL,
    search: '',
  }

  return {
    statusOptions: buildGatewayListStatusOptions(sources, filterSlice),
    runtimeOptions: buildGatewayListRuntimeOptions(sources, filterSlice),
    moduleOptions: buildGatewayListModuleOptions(sources, filterSlice),
    projectKeyOptions: buildGatewayListProjectKeyOptions(sources, projectKeyGroups, filterSlice),
  }
}
